import { FormattedMessage, useIntl } from 'react-intl';

import type { TermedLevel } from '../../common/termedLevel/types';
import { getRenewsToProductLabelFromContract } from '../../common/utils/productLabelUtil';

interface Props {
    contract: TermedLevel;
}

export function ContractTableRowRenewalText({ contract }: Props) {
    const intl = useIntl();

    return contract.renewsToLevel === undefined ? (
        <>
            <span className='rioglyph rioglyph-remove text-color-danger margin-right-3' />
            <FormattedMessage id='marketplace.contracts.notRenewed' />
        </>
    ) : (
        <>
            <span className='rioglyph rioglyph-repeat text-color-success margin-right-3' />
            {getRenewsToProductLabelFromContract(contract, intl)}
        </>
    );
}
